module.exports = __webpack_public_path__ + "img/menu_item4.2026fbf2.svg";